export default class LimitIncreaseResponse {

    constructor(jsonObj) {
        this.id = jsonObj["id"];
        this.registrationId = jsonObj["registration-id"];
        this.requestDate = jsonObj["request-date"];
        this.status = jsonObj["status"];
        this.registeringPartnerId = jsonObj["registering-partner-id"];
        this.registeringPartnerUserId = jsonObj["registering-partner-user-id"];
        this.registeringChannelId = jsonObj["registering-channel-id"];
        this.displayStatus = jsonObj["status-display"];
    }
}